import Expander, {
  ExpanderIconType,
} from "components/components/Expander/Expander";
import { RevisionHistoryModel } from "models/remit/revisionHistoryModel";
import { SelectedMessageRevision } from "pages/RemitMessageDetails/RemitMessageDetails";
import {
  OldSidebarContainer,
  OldSidebarContent,
  OldSidebarRevisionButton,
  OverflowContainer,
  SidebarContainer,
  SidebarContent,
  SidebarHeader,
  SidebarRevisionButton,
} from "pages/RemitMessageDetails/style";
import React from "react";
import { DateFormat, formatDateTimeString } from "utils/dateHelpers";
import featureFlags from "utils/featureFlags";
import { getDisplayNameFromJsonKey } from "utils/remitHelpers";

interface Props {
  revisionHistory: RevisionHistoryModel[];
  selectedMessageRevision: SelectedMessageRevision;
  setUrlParams: (params: { messageId: string }) => void;
  latestRevisionId: number;
}

const SidebarContentComponent = featureFlags.rebrand
  ? SidebarContent
  : OldSidebarContent;
const SidebarRevisionButtonComponent = featureFlags.rebrand
  ? SidebarRevisionButton
  : OldSidebarRevisionButton;
const SidebarContainerComponent = featureFlags.rebrand
  ? SidebarContainer
  : OldSidebarContainer;

const RemitSidebar: React.FC<Props> = ({
  revisionHistory,
  selectedMessageRevision,
  setUrlParams,
  latestRevisionId,
}) => (
  <SidebarContainerComponent
    className={
      selectedMessageRevision.messageId === latestRevisionId
        ? ""
        : "warning-box-active"
    }
  >
    <OverflowContainer>
      <SidebarHeader>{`Revision history (${revisionHistory?.length})`}</SidebarHeader>
      {revisionHistory &&
        revisionHistory.map((revision, i) => (
          <Expander
            isFirst={i === 0}
            key={revision.id}
            title={`Revision ${revision.revisionNumber}`}
            subtitle={formatDateTimeString(
              new Date(revision.publishTime),
              DateFormat.DateTimeWithSeconds
            )}
            content={
              <SidebarContentComponent>
                {i < revisionHistory.length - 1 &&
                  revisionHistory[i].changesFromPreviousRevision &&
                  revisionHistory[i].changesFromPreviousRevision.length > 0 && (
                    <>
                      <p>Changes from previous revision:</p>
                      <ul>
                        {revisionHistory[i].changesFromPreviousRevision.map(
                          (difference) => (
                            <li key={difference}>
                              {getDisplayNameFromJsonKey(difference)}
                            </li>
                          )
                        )}
                      </ul>
                    </>
                  )}
                {selectedMessageRevision.messageId === revision.id ? (
                  <SidebarRevisionButtonComponent
                    buttonText="Viewing"
                    disabled
                  />
                ) : (
                  <SidebarRevisionButtonComponent
                    buttonText="View Revision"
                    onClick={(): void =>
                      setUrlParams({
                        messageId: revision.id.toString(),
                      })
                    }
                  />
                )}
              </SidebarContentComponent>
            }
            classModifier={
              revision.id === selectedMessageRevision.messageId
                ? "sidebar-item active"
                : "sidebar-item"
            }
            expanderIconType={ExpanderIconType.Arrow}
          />
        ))}
    </OverflowContainer>
  </SidebarContainerComponent>
);

export default RemitSidebar;
